import { render, staticRenderFns } from "./UcContractRentalServices.yaml?vue&type=template&id=10093fd7&component"
import script from "./UcContractRentalServices.yaml?vue&type=script&lang=ts&component"
export * from "./UcContractRentalServices.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports